import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { stdObject } from "../../data/types/stdObject";
import useScreenSize from "../../utils/getDimentions";
import { maxCalendarSize, maxMobileSize } from "../../data/main";
import { useReactToPrint } from "react-to-print";
import { useMainContext } from "../../context/MainContext";
import { getCurrentMonth } from "../../utils/getCurrentMonth";
import { getCurrentDate } from "../../utils/getCurrentDate";
import {
  startCalendar,
  getWeekStart,
} from "../../screens/MainStructure/components/Calendar/calendarFunctions";

const checkDimValues = (sizes: stdObject) => {
  return {
    active: sizes.width <= maxCalendarSize,
    size:
      sizes.width <= maxCalendarSize
        ? sizes.width < sizes.height
          ? "v"
          : "h"
        : false,
  };
};

export default function useCalendarModal({
  open = false,
  close = () => {},
}: {
  open: boolean;
  close: (v: boolean | string) => void;
}) {
  const screenSize = useScreenSize();
  const user: any = useSelector((state: RootState) => state.data.user);
  const listRow: any = useSelector((state: RootState) => state.data.listRow);

  const [secondFlex, setSecondFlex] = useState(checkDimValues(screenSize));

  const [selected, setSelected] = useState<string>("");
  const [selectedWeek, setSelectedWeek] = useState<string>("");
  const [calendarDays, setCalendarDays] = useState<stdObject>({});
  const [calendarView, setCalendarView] = useState<string>("month");
  const { logoutAction, setCalDocsList } = useMainContext();

  const selectDay = (dateStr: string) => {
    setSelected(dateStr);
    setSelectedWeek("");
  };

  const selectWeek = (weekStart: string) => {
    setSelectedWeek(weekStart);
    setSelected("");
  };

  const changeCalendarView = (view: string) => {
    setCalendarView(view);
    const actualMonth = getCurrentMonth()
      .map((e: number, index: number) => (index > 0 && e < 10 ? "0" + e : e))
      .join("-");
    const isCurrentMonth = currentMonth === actualMonth;
    const today = getCurrentDate();
    if (view === "day" && selected === "") {
      selectDay(isCurrentMonth ? today : `${currentMonth}-01`);
    } else if (view === "week" && selectedWeek === "") {
      selectWeek(getWeekStart(isCurrentMonth ? today : `${currentMonth}-01`));
    }
  };

  const loadCalendar = () => {
    startCalendar(currentMonth, {
      user,
      logoutAction,
      setCalDocsList,
      setCalendarDays,
    });
  };
  const [headerInfo, setHeaderInfo] = useState<Array<stdObject>>([]);
  const [minModalWidth, setMinModalWidth] = useState<boolean>(false);
  const [currentMonth, setCurrentMonth] = useState<string>(
    getCurrentMonth()
      .map((e: number, index: number) => (index > 0 && e < 10 ? "0" + e : e))
      .join("-"),
  );

  const squareButtons = [{ Icon: CloseIcon, onClick: close }];

  const recordsRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: recordsRef } as any);

  useEffect(() => {
    if (open) {
      if (minModalWidth && screenSize.width > maxCalendarSize) {
        setMinModalWidth(false);
      }
      if (!minModalWidth && screenSize.width <= maxCalendarSize) {
        setMinModalWidth(true);
      }
    }
  }, [screenSize]);

  useEffect(() => {
    if (headerInfo.length > 0) {
      reactToPrintFn();
      setHeaderInfo([]);
    }
  }, [headerInfo]);

  useEffect(() => {
    const okWidth = screenSize.width <= maxCalendarSize;
    setSecondFlex({
      active: okWidth,
      size: okWidth
        ? screenSize.width < screenSize.height
          ? "v"
          : "h"
        : false,
    });
  }, [screenSize]);

  useEffect(() => {
    loadCalendar();
  }, [currentMonth]);

  useEffect(() => {
    if (listRow.type === "SEV") {
      loadCalendar();
    }
  }, [listRow]);

  const isBigScreen = screenSize.width > maxCalendarSize;
  const isMediumcreen = screenSize.width > maxMobileSize;
  const isVertical = screenSize.width < screenSize.height;

  return {
    selected,
    selectDay,
    selectedWeek,
    selectWeek,
    secondFlex,
    calendarDays,
    setCalendarDays,
    isBigScreen,
    isMediumcreen,
    isVertical,
    squareButtons,
    currentMonth,
    setCurrentMonth,
    calendarView,
    changeCalendarView,
  };
}
